<template>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
  <div class="container">
    <!-- Message d'erreur -->
    <div v-if="error" class="alert alert-dark text-center my-5">
      <h3>{{ t('profile.notAvailable') }}</h3>
      <p>{{ error }}</p>
    </div>
    
    <!-- État de chargement principal avec skeleton loader (sans motif de fond) -->
    <div v-else-if="isLoading" class="loading-container">
      <!-- Skeleton Banner -->
      <div class="banner skeleton-banner"></div>
      
      <!-- Skeleton Content -->
      <div class="content">
        <!-- Skeleton Share Button -->
        <div class="share-button skeleton"></div>

        <!-- Skeleton Profile -->
        <div class="profile">
          <div class="profile-image-container skeleton"></div>
          <div class="skeleton-text skeleton-name"></div>
          <div class="skeleton-text skeleton-bio"></div>
        </div>

        <!-- Skeleton Links -->
        <div class="links">
          <div class="link-item skeleton" v-for="i in 4" :key="i"></div>
        </div>
      </div>
    </div>
    
    <!-- Contenu principal (affiché uniquement une fois chargé) -->
    <div v-else>
      <!-- Background Pattern - apparaît uniquement quand le contenu est chargé -->
      <div class="background-pattern"></div>  
      
      <!-- Banner -->
      <div class="banner">
        <div class="banner-overlay"></div>
        
        <!-- Si c'est une bannière personnalisée -->
        <img v-if="user?.banner_type === 'custom' && user?.banner_path" 
             :src="`${BASE_URL}${user.banner_path}`" 
             :alt="t('alt.banner')" 
             class="banner-image" />
        
        <!-- Si c'est une bannière générée par le thème -->
        <img v-else-if="user?.banner_path" 
             :src="`${BASE_URL}${user.banner_path}`" 
             :alt="t('alt.banner')" 
             class="banner-image" />
        
        <!-- Image par défaut si aucune bannière n'est définie -->
        <img v-else 
             src="@/assets/images/cvr2.png" 
             :alt="t('alt.banner')" 
             class="banner-image" />
      </div>
      
      <!-- Content -->
      <div class="content">
        <!-- Share Button -->
   <button    
    class="share-button"    
    @click="handleShare"    
    :title="t('share.button')">   
    <i class="fas fa-share-alt"></i> 
</button>

        <!-- Modal de partage -->
        <div v-if="isShareModalOpen" class="share-modal">
          <div class="share-modal-content">
            <div class="share-modal-header">
              <h4>{{ t('share.title') }}</h4>
              <button class="close-button" @click="closeShareModal">×</button>
            </div>
            
            <div class="content-layout">
              <!-- QR Code (gauche) -->
              <div class="qr-code-container">
                <img :src="qrCodeUrl" :alt="t('alt.qrcode')" class="qr-image">
              </div>
              
              <!-- Options de partage (droite) -->
              <div class="share-options">
                <!-- Twitter -->
                <div class="share-option" @click="shareVia('twitter')">
                  <div class="social-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </div>
                  <span>{{ t('share.twitter') }}</span>
                  <div class="chevron-right">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M9 18l6-6-6-6"/>
                    </svg>
                  </div>
                </div>
                
                <!-- Facebook -->
                <div class="share-option" @click="shareVia('facebook')">
                  <div class="social-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </div>
                  <span>{{ t('share.facebook') }}</span>
                  <div class="chevron-right">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M9 18l6-6-6-6"/>
                    </svg>
                  </div>
                </div>
                
    


                <!-- Whatssap -->

<div class="share-option" @click="shareVia('whatsapp')">
  <div class="social-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
    </svg>
  </div>
  <span>{{ t('share.whatsapp') }}</span>
  <div class="chevron-right">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M9 18l6-6-6-6"/>
    </svg>
  </div>
</div>
              </div>
            </div>
            
            <!-- URL Copy (bas) -->
            <div class="url-copy">
              <div class="url-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
              </div>
              <input type="text" readonly :value="profileUrl || window.location.href" class="url-input">
              <button class="copy-button" @click="copyProfileUrl">{{ copied ? t('share.copied') : t('share.copy') }}</button>
            </div>
          </div>
        </div>

        <!-- Profile -->
        <div class="profile">
          <div class="profile-image-container">
            <div class="profile-image-blur"></div>
            <img :src="`${BASE_URL}${user?.avatar_path}`" :alt="user?.name || t('alt.profile')" class="profile-image">
          </div>
          <h1 class="profile-name">
            {{ user?.name }}
            <img src="@/assets/images/ch.png" :alt="t('alt.verified')" class="verified-icon">
          </h1>

          <!-- Social Icons Bar - masquée comme demandé -->
          <!-- <div class="social-icons-bar">
            // Section masquée selon la demande du client
          </div> -->

          <p class="profile-bio">{{ user?.bio }}</p>
        </div>

        <!-- Links - Style inspiré de la troisième capture d'écran -->
        <div class="links">
          <!-- Email -->
          <a v-if="user?.email" 
             class="link-item" 
             role="button"
             @click="showLinkOptions({
                 platform: 'Email', 
                 url: user.email, 
                 icon: 'fas fa-envelope'
             })">
            <div class="link-icon">
              <i class="fas fa-envelope"></i>
            </div>
            <span>{{ t('profile.email') }}</span>
          </a>

          <!-- Réseaux sociaux dynamiques -->
          <a v-for="link in socialLinks" 
             :key="link.id" 
             class="link-item"
             :href="link.url"
             target="_blank"
             @click.prevent="showLinkOptions(link)">
            <div class="link-icon">
              <template v-if="link.platform.toLowerCase() === 'yellowdjibouti'">
                <img 
                  src="@/assets/images/yellow.png" 
                  alt="yellowdjibouti" 
                  class="custom-icon-yellow"
                />
              </template>
              <i v-else :class="link.icon"></i>
            </div>

<span>
  {{ link.type === 'custom' ? (link.title || t('profile.customLink')) : (link.title || link.platform) }}
</span>   


    </a>

          <!-- Gallery -->
          <div v-if="photos.length > 0" class="link-item gallery-item">
            <button class="gallery-button" @click="toggleGallery">
              <div class="gallery-content">
                <div class="link-icon">
                  <i class="fas fa-images"></i>
                </div>
                <span>{{ t('profile.gallery') }}</span>
              </div>
              <i :class="`fas fa-chevron-down chevron ${isGalleryActive ? 'active' : ''}`"></i>
            </button>

            <div class="gallery-grid" :class="{ active: isGalleryActive }">
              <img v-for="photo in photos" 
                :key="photo.id" 
                :src="`${BASE_URL}${photo.photo_path}`" 
                :alt="photo.title || t('alt.gallery')"
                class="gallery-image">
            </div>
          </div>




          <!-- AJOUTER DANS NeolinkView.vue APRÈS LES RÉSEAUX SOCIAUX ET AVANT LA GALERIE -->

<!-- Services personnalisés -->

<div v-for="service in services"
     :key="`service-${service.id}`"
     class="link-item service-item"
     :data-type="service.type"
     @click="handleServiceClick(service)">
     
  <!-- Type Link: Affichage simple comme les réseaux sociaux -->
  <template v-if="service.type === 'link'">
    <div class="link-icon">
      <img v-if="service.icon_path"
           :src="`${BASE_URL}${service.icon_path}`"
           :alt="service.name"
           class="service-icon-small">
      <i v-else class="fas fa-cog"></i>
    </div>
    <span>{{ service.name }}</span>
  </template>
  
  <!-- Type Button: Affichage avec image plus grande -->
  <template v-else-if="service.type === 'button'">
    <div class="service-button-content">
      <!-- Image du service -->
      <div class="service-image-container">
        <img v-if="service.icon_path"
             :src="`${BASE_URL}${service.icon_path}`"
             :alt="service.name"
             class="service-image">
        <div v-else class="service-image-placeholder">
          <i class="fas fa-cog"></i>
        </div>
      </div>
      
      <!-- Nom du service -->
      <span class="service-button-name">{{ service.name }}</span>
    </div>
  </template>
</div>
        </div>

        <!-- Footer - style du deuxième fichier modifié pour le logo cliquable -->
      


      <!-- Share Button - Affiché seulement si le mode business est activé -->
<button 
  v-if="user && user.show_contact_button == 1" 
  class="share-button" 
  @click="handleShare" 
  :title="t('share.button')">
  <i class="fas fa-share-alt"></i>
</button>

<!-- Footer avec logo Neolink conditionnel et lien toujours visible -->
<div class="create-profile-container">
  <!-- Logo Neolink cliquable - SEULEMENT si le mode business est activé -->
 <!--  <button 
    v-if="user && user.show_contact_button == 1"
    @click="saveContact" 
    class="neolink-logo-container" 
    :title="t('contact.download')">
    <img src="@/assets/neolink.png" alt="Neolink" class="neolink-logo">
    <div class="logo-tooltip">
      <i class="fas fa-download"></i>
      <span>{{ t('contact.download') }}</span>
    </div>
  </button> -->



  <!-- Bouton Save Contact - SEULEMENT si le mode business est activé -->
<button 
  v-if="user && user.show_contact_button == 1"
  @click="saveContact" 
  class="save-contact-button">
  <i class="fas fa-download"></i>
  <span>{{ t('contact.save') }}</span>
</button>
  
  <!-- Lien vers la création de profil - TOUJOURS VISIBLE -->
  <a href="https://neolinks.me/inscription" class="create-profile-link">
    <span class="highlight-text">{{ t('footer.create') }}</span> {{ t('footer.createProfile') }}
  </a>
</div>

        <!-- Modal pour choisir l'ouverture -->
        <div v-if="showModal" class="modal">
          <div class="modal-content">
            <h3>{{ t('modal.openWith') }}</h3>
            <button @click="openInApp" class="app-button">
              <i class="fas fa-mobile-alt"></i>
              {{ t('modal.application') }} {{ currentLink?.platform }}
            </button>
            <button @click="openInBrowser" class="browser-button">
              <i class="fas fa-globe"></i>
              {{ t('modal.browser') }}
            </button>
            <button @click="closeModal" class="cancel-button">
              <i class="fas fa-times"></i>
              {{ t('modal.cancel') }}
            </button>
          </div>
        </div>

        <!-- Bottom Buttons -->
        <div class="bottom-buttons d-none" v-if="user && user.show_contact_button == 1">
          <button :class="`bottom-button save-button ${isSaved ? 'active' : ''}`" @click="saveContact">
            <i class="far fa-bookmark"></i>
            <span>{{ t('contact.save') }}</span>
          </button>
        </div>
      </div> <!-- Fin de la div content -->
    </div> <!-- Fin de la div v-else -->
  </div> <!-- Fin de la div container -->
</template>
<script>
/* eslint-disable */ 
import { ref, watch, onMounted, computed } from 'vue';
import { dashboardService } from '@/services/api';
import { useRoute } from 'vue-router';
import { usePublicProfileTranslation } from '@/composables/usePublicProfileTranslation';


export default {
  name: 'NeolinkView',

  setup() {
    const BASE_URL = '';  // Déclarez BASE_URL ici
    //LangueDetection
    const { t, currentLanguage, getLanguageInfo } = usePublicProfileTranslation();

    // Nouvel état pour le chargement
    const isLoading = ref(true);


    const services = ref([]); // NOUVEAU

    const dataLoaded = ref({
      user: false,
      links: false,
      photos: false,
      theme: false,
      services: false  // AJOUTER CETTE LIGNE

    });

    const availableSocialPlatforms = computed(() => {
      return socialPlatforms.filter(platform => getSocialLink(platform.name) !== null);
    });

    const user = ref(null);
    const socialLinks = ref([]);
    const photos = ref([]);
    const isGalleryActive = ref(false);
    const showModal = ref(false);
    const currentLink = ref(null);
    const isSaved = ref(false);
    const isFavorite = ref(false);
    const route = useRoute();
    const error = ref(null);
    
    // Variables pour le modal de partage
    const isShareModalOpen = ref(false);
    const copied = ref(false);
    const qrCodeUrl = ref("");
    const profileUrl = ref("");
    const theme = ref(null);

    // Pour le toggle de la galerie
    const toggleGallery = () => {
      isGalleryActive.value = !isGalleryActive.value;
    };


    const loadUserServices = async () => {
  try {
    const username = route.params.username;
    const servicesRes = await dashboardService.getUserServices(username);
    
    if (servicesRes.data && servicesRes.data.success) {
      services.value = servicesRes.data.data || [];
    }
  } catch (error) {
    console.error('Erreur de chargement des services:', error);
    services.value = [];
  } finally {
    // MARQUER COMME CHARGÉ MÊME EN CAS D'ERREUR
    dataLoaded.value.services = true;
  }
};

    // Vérifier quand toutes les données sont chargées
    watch(() => [
      dataLoaded.value.user,
      dataLoaded.value.links,
      dataLoaded.value.photos,
      dataLoaded.value.theme,
      dataLoaded.value.services  // AJOUTER CETTE LIGNE


    ], ([userLoaded, linksLoaded, photosLoaded, themeLoaded, servicesLoaded]) => {
      // Si tout est chargé ou si une erreur est présente, on arrête le chargement
      if ((userLoaded && linksLoaded && photosLoaded && themeLoaded, servicesLoaded) || error.value) {
        // Ajouter un délai court pour assurer que le DOM est bien mis à jour
        setTimeout(() => {
          isLoading.value = false;
          
          // Une fois le chargement terminé, afficher le motif de lignes
          setTimeout(() => {
            // Supprimer le style qui cachait le motif
            const loadingStyle = document.getElementById('loading-style');
            if (loadingStyle) {
              loadingStyle.remove();
            }
            
            // Appliquer explicitement le motif de lignes
            const patternElement = document.querySelector('.background-pattern');
            if (patternElement) {
              // Restaurer l'affichage du motif de lignes
              patternElement.style.display = 'grid';
              patternElement.style.gridTemplateColumns = 'repeat(36, 1fr)';
              patternElement.style.opacity = theme.value?.variables?.patternOpacity || '0.1';
              
              // S'assurer que le pseudo-élément est correctement configuré
              const styleElement = document.getElementById('background-pattern-style');
              if (!styleElement) {
                const newStyle = document.createElement('style');
                newStyle.id = 'background-pattern-style';
                newStyle.textContent = `
                  .background-pattern::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-image: repeating-linear-gradient(
                      to right,
                      var(--primaryText, #9ca3af) 0px,
                      var(--primaryText, #9ca3af) 1px,
                      transparent 1px,
                      transparent calc(100% / 36)
                    );
                  }
                `;
                document.head.appendChild(newStyle);
              }
            }
          }, 200);
        }, 100);
      }
    }, { deep: true });

    watch(() => user.value, (newUser) => {
      if (newUser) {
        // Mettre à jour le titre
        document.title = newUser.name ? `${newUser.name} | Neolinks` : 'Carte Digitale | Neolink';
        
        // Description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
          metaDescription = document.createElement('meta');
          metaDescription.setAttribute('name', 'description');
          document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', newUser.bio || 'Carte de visite numérique personnalisée');
        
        // Image Open Graph
        let ogImage = document.querySelector('meta[property="og:image"]');
        if (!ogImage) {
          ogImage = document.createElement('meta');
          ogImage.setAttribute('property', 'og:image');
          document.head.appendChild(ogImage);
        }
        if (newUser.avatar_path) {
          ogImage.setAttribute('content', `${window.location.origin}${BASE_URL}${newUser.avatar_path}`);
        }
      }
    }, { deep: true });

    const findSocialLink = (platform) => {
      return socialLinks.value.find(link => 
        link.platform.toLowerCase() === platform.toLowerCase()
      );
    };



    // Amélioration du chargement de données avec gestion d'état
    const loadUserData = async () => {
      try {
        const username = route.params.username;
        console.log('Chargement des données pour:', username);
        
        // Précharger les images
        const preloadImage = (src) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = src;
          });
        };

        // Charger les données utilisateur
        const userRes = await dashboardService.getUserProfile(username);
        console.log('Réponse API complète:', userRes);
        
        if (!userRes.data.success) {
          error.value = userRes.data.message || "Cet utilisateur n'a pas d'abonnement actif";
          dataLoaded.value.user = true; // Marquer comme chargé même en cas d'erreur
          dataLoaded.value.services = true; // MARQUER COMME CHARGÉ EN CAS D'ERREUR

          return;
        }
        
        // Vérifier que la réponse contient bien des données
        if (userRes.data && userRes.data.success === true && userRes.data.data) {
          console.log('Données utilisateur trouvées:', userRes.data.data);

          // Vérifier si l'abonnement est actif
          if (!userRes.data.data.statut || userRes.data.data.statut !== 1) {
            error.value = "Cet utilisateur n'a pas d'abonnement actif";
            dataLoaded.value.user = true;
            dataLoaded.value.services = true; // MARQUER COMME CHARGÉ EN CAS D'ERREUR

            return;
          }
          
          user.value = userRes.data.data;
          dataLoaded.value.user = true;
          
          // Précharger l'avatar et la bannière
          if (user.value.avatar_path) {
            preloadImage(`${BASE_URL}${user.value.avatar_path}`).catch(() => console.log('Erreur de préchargement avatar'));
          }
          
          if (user.value.banner_path) {
            preloadImage(`${BASE_URL}${user.value.banner_path}`).catch(() => console.log('Erreur de préchargement bannière'));
          }
          
          // Charger les liens et photos en parallèle
          try {
            const [linksRes, photosRes] = await Promise.all([
              dashboardService.getUserSocialLinks(username),
              dashboardService.getUserPhotos(username),

            ]);
            
            socialLinks.value = linksRes.data.data || [];
            dataLoaded.value.links = true;
            
            // Traiter les photos
            const photosData = photosRes.data.data || [];
            photos.value = photosData;
            dataLoaded.value.photos = true;

            // Précharger les photos de la galerie
            if (photosData.length > 0) {
              photosData.forEach(photo => {
                if (photo.photo_path) {
                  preloadImage(`${BASE_URL}${photo.photo_path}`).catch(() => {});
                }
              });
            }


            await loadUserServices();

          } catch (error) {
            console.error('Erreur lors du chargement des liens ou photos:', error);
            dataLoaded.value.links = true;
            dataLoaded.value.photos = true;
          }
        } else {
          console.error('Aucune donnée utilisateur dans la réponse');
          error.value = "Profil introuvable";
          dataLoaded.value.user = true;
        }
      } catch (error) {
        console.error('Erreur de chargement:', error);
        error.value = "Erreur lors du chargement du profil";
        // Marquer toutes les données comme chargées en cas d'erreur
        dataLoaded.value.user = true;
        dataLoaded.value.links = true;
        dataLoaded.value.photos = true;
      }
    };

    const handleShare = () => {
      // Mettre à jour l'URL du profil
      try {
        profileUrl.value = window.location.href;
      } catch (e) {
        profileUrl.value = '';
      }
      
      // Utiliser directement le QR code existant s'il est disponible
      if (user.value && user.value.qr_code_path) {
        qrCodeUrl.value = `${BASE_URL}${user.value.qr_code_path}`;
      } else {
        // Fallback au cas où aucun QR code n'existe
        qrCodeUrl.value = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(profileUrl.value || '')}`;
      }
      
      isShareModalOpen.value = true;
      copied.value = false;
      
      // Empêcher le défilement
      document.body.style.overflow = 'hidden';
    };

    const closeShareModal = () => {
      isShareModalOpen.value = false;
      document.body.style.overflow = '';
    };

    const copyProfileUrl = async () => {
      try {
        // Récupère l'élément input avec la classe url-input
        const urlInput = document.querySelector('.url-input');
        
        if (!urlInput) {
          console.error("Élément d'entrée URL introuvable");
          return;
        }

        // Sélection du texte
        urlInput.select();
        
        // Pour iOS, on doit définir la plage de sélection manuellement
        urlInput.setSelectionRange(0, 99999);

        // Approche moderne : utiliser l'API Clipboard si disponible
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(urlInput.value);
          console.log("Texte copié avec l'API Clipboard");
        } 
        // Méthode de secours pour les navigateurs plus anciens ou non-sécurisés
        else {
          // La méthode execCommand est dépréciée mais utile comme fallback
          const result = document.execCommand('copy');
          if (!result) {
            console.error("La copie a échoué avec execCommand");
          } else {
            console.log("Texte copié avec execCommand");
          }
        }

        // Mettre à jour l'état pour montrer que la copie a réussi
        copied.value = true;
        
        // Optionnel : changer le texte du bouton pour indiquer la réussite
        const copyButton = document.querySelector('.copy-button');
        if (copyButton) {
          const originalText = copyButton.textContent;
          copyButton.textContent = "Copied!";
          
          setTimeout(() => {
            copyButton.textContent = originalText;
            copied.value = false;
          }, 2000);
        } else {
          // Si on ne peut pas accéder au bouton, simplement réinitialiser l'état après un délai
          setTimeout(() => {
            copied.value = false;
          }, 2000);
        }
      } catch (err) {
        console.error("Erreur lors de la copie :", err);
      }
    };

const shareVia = (platform) => {
  const url = profileUrl.value;
  
  let shareUrl = '';
  
  switch (platform) {
    case 'twitter':
      // Twitter avec juste l'URL et hashtags
      shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&hashtags=neolinks,DigitalProfile,business`;
      break;
      
    case 'facebook':
      // Facebook avec juste l'URL (meta tags auto-récupérées)
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
      break;
      
    case 'whatsapp':
      // WhatsApp avec juste l'URL (meta tags auto-récupérées)
      shareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
      break;
  }
  
  if (shareUrl) {
    window.open(shareUrl, '_blank');
  }
  
  closeShareModal();
};
   






// Fonction pour détecter le navigateur Instagram
function isInstagramBrowser() {
  return navigator.userAgent.includes('Instagram');
}

// Fonction modifiée pour ouvrir les liens
const openLink = async (link) => {
  if (!link) return;
  
  const url = link.url;
  const platform = link.platform.toLowerCase();
  
  // Gestion spécifique pour téléphone et email (inchangée)
  if (platform === 'mobile') {
    window.location.href = `tel:${url}`;
    return;
  }
  if (platform === 'email') {
    window.location.href = `mailto:${url}`;
    return;
  }
  
  // Spécial pour Instagram webview
  if (isInstagramBrowser()) {
    // Utiliser les URLs universelles pour les réseaux sociaux populaires
    let universalUrl = url;
    
    // Extraire l'identifiant ou le nom d'utilisateur de l'URL
    const getUsername = (url) => url.split('/').pop().split('?')[0];
    const username = getUsername(url);
    
    switch (platform) {
      case 'twitter':
      case 'x':
        universalUrl = `https://twitter.com/${username}`;
        break;
      case 'facebook':
        universalUrl = `https://www.facebook.com/${username}`;
        break;
      case 'instagram':
        universalUrl = `https://www.instagram.com/${username}`;
        break;
      case 'linkedin':
        universalUrl = `https://www.linkedin.com/in/${username}`;
        break;
      case 'tiktok':
        universalUrl = `https://www.tiktok.com/@${username}`;
        break;
      // Autres réseaux si nécessaire
    }
    
    // Ouvrir en utilisant window.location.href pour forcer l'ouverture
    // Cela peut aider à éviter certaines restrictions d'Instagram
    window.location.href = universalUrl;
  } else {
    // Comportement normal pour les autres navigateurs
    window.open(url, '_blank');
  }
};

// La fonction showLinkOptions reste presque identique
const showLinkOptions = (link) => {
  if (!link || !link.url) {
    console.error('Invalid link object:', link);
    return;
  }
  
  // Enregistrer le clic
  if (user.value && user.value.id && link.id) {
    dashboardService.recordLinkClick(user.value.id, link.id)
      .catch(err => console.error('Erreur lors de l\'enregistrement du clic:', err));
  }
  
  // Ouvrir le lien
  openLink(link);
};

    const openInApp = () => {
      const link = currentLink.value;
      if (!link) return;

      const url = link.url;
      const platform = link.platform.toLowerCase();

      switch(platform) {
        case 'mobile':
          window.location.href = `tel:${url}`;
          break;
        case 'twitter':
          window.location.href = `twitter://user?screen_name=${getUsername(url)}`;
          break;
        case 'facebook':
          window.location.href = `fb://profile/${getFacebookId(url)}`;
          break;
        case 'instagram':
          window.location.href = `instagram://user?username=${getUsername(url)}`;
          break;
        case 'linkedin':
          window.location.href = `linkedin://profile/${getLinkedinId(url)}`;
          break;
        case 'youtube':
          window.location.href = `vnd.youtube://${getYoutubeId(url)}`;
          break;
        default:
          window.open(url, '_blank');
      }
      closeModal();
    };

    const openInBrowser = () => {
      console.log('Opening in browser');
      const link = currentLink.value;
      if (!link) {
        console.log('No current link');
        return;
      }

      console.log('Current link:', link);
      let finalUrl;
      const url = link.url;
      const platform = link.platform.toLowerCase();
      console.log('Platform:', platform, 'URL:', url);

      switch(platform) {
        case 'mobile':
          finalUrl = `tel:${url}`;
          break;
        case 'email':
          finalUrl = `mailto:${url}`;
          break;
        case 'twitter':
          finalUrl = `https://twitter.com/${getUsername(url)}`;
          break;
        case 'facebook':
          finalUrl = `https://facebook.com/${getFacebookId(url)}`;
          break;
        case 'linkedin':
        case 'youtube':
        case 'instagram':
          finalUrl = url.startsWith('http') ? url : `https://${url}`;
          break;
        default:
          finalUrl = url.startsWith('http') ? url : `https://${url}`;
      }

      console.log('Final URL:', finalUrl);
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
      closeModal();
    };

    const closeModal = () => {
      console.log('Closing modal');
      showModal.value = false;
      currentLink.value = null;
    };

    // Extraire les identifiants des URLs
    const getUsername = (url) => {
      return url.split('/').pop();
    };

    const getFacebookId = (url) => {
      return url.split('/').pop();
    };

    const getLinkedinId = (url) => {
      return url.split('/').pop();
    };

    const getYoutubeId = (url) => {
      return url.split('v=')[1];
    };

    // Sauvegarder contact
    const saveContact = async () => {
      try {
        // Préparer les données du contact
        const contact = {
          name: user.value.name,
          phone: user.value.mobile,
          email: user.value.email
        };

        // Récupérer l'image de profil
        let photoData = null;
        if (user.value && user.value.avatar_path) {
          try {
            // Convertir l'image en base64
            const avatarUrl = `${BASE_URL}${user.value.avatar_path}`;
            const response = await fetch(avatarUrl);
            const blob = await response.blob();
            
            // Convertir le blob en base64
            photoData = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                // Extraire la partie base64 du résultat (supprimer le préfixe data:image/jpeg;base64,)
                const base64data = reader.result.split(',')[1];
                resolve(base64data);
              };
              reader.readAsDataURL(blob);
            });
          } catch (photoError) {
            console.error('Erreur lors de la récupération de la photo de profil:', photoError);
            // Continuer sans la photo si une erreur se produit
          }
        }

        // Créer le vCard avec photo si disponible
        let vCardLines = [
          'BEGIN:VCARD',
          'VERSION:3.0',
          `FN:${contact.name}`,
          contact.phone ? `TEL;TYPE=CELL:${contact.phone}` : '',
          contact.email ? `EMAIL:${contact.email}` : '',
          profileUrl.value ? `URL:${profileUrl.value}` : '' // UTILISER profileUrl DIRECTEMENT

        ];

        // Ajouter la photo si disponible
        if (photoData) {
          vCardLines.push(`PHOTO;ENCODING=b;TYPE=JPEG:${photoData}`);
        }

        vCardLines.push('END:VCARD');

        // Filtrer les lignes vides et joindre avec des retours à la ligne
        const vCard = vCardLines.filter(line => line !== '').join('\r\n');

        // Télécharger le fichier vCard
        const blob = new Blob([vCard], { type: 'text/vcard;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${contact.name.replace(/\s+/g, '_')}_contact.vcf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        isSaved.value = true;
      } catch (error) {
        console.error('Erreur lors de la sauvegarde du contact:', error);
        alert('Erreur lors de la sauvegarde du contact.');
      }
    };

    // Ajouter aux favoris
    const addToFavorites = (e) => {
      e.preventDefault(); // Empêcher l'actualisation

      if (window.confirm('Voulez-vous ajouter cette page aux favoris ?')) {
        const title = document.title;
        const url = window.location.href;

        // Détection mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (isMobile) {
          // Solution pour mobile
          if (navigator.share) {
            navigator.share({
              title: title,
              url: url
            });
          } else {
            alert('Utilisez la fonction favoris de votre navigateur');
          }
        } else {
          // Solution pour PC
          try {
            // Création d'un lien temporaire
            const link = document.createElement('a');
            link.href = url;
            link.title = title;
            link.rel = 'sidebar'; // Pour Firefox
            document.body.appendChild(link);
            
            // Simuler Ctrl+D
            const e = document.createEvent('KeyboardEvent');
            e.initKeyEvent('keypress', true, true, window,
              true, false, false, false,
              68, 0);
            document.dispatchEvent(e);
            
            document.body.removeChild(link);
            
            alert('Appuyez sur Ctrl + D pour confirmer l\'ajout aux favoris');
          } catch(err) {
            alert('Utilisez Ctrl + D pour ajouter aux favoris');
          }
        }
        isFavorite.value = true;
      }
    };

    // Fonction pour charger le thème de l'utilisateur
    const loadUserTheme = async () => {
      try {
        const username = route.params.username;
        const themeRes = await dashboardService.getUserTheme(username);
        
        if (themeRes.data && themeRes.data.success && themeRes.data.data) {
          theme.value = themeRes.data.data;
          applyTheme(theme.value.variables);
        } else {
          // Thème par défaut si aucun thème n'est défini
          setDefaultTheme();
        }
        
        // Marquer le thème comme chargé
        dataLoaded.value.theme = true;
      } catch (error) {
        console.error('Erreur de chargement du thème:', error);
        setDefaultTheme();
        dataLoaded.value.theme = true;
      }
    };

    // Appliquer les variables du thème au CSS
    const applyTheme = (themeVars) => {
      if (!themeVars) return;
      
      // Si themeVars est une chaîne JSON, on la parse
      const vars = typeof themeVars === 'string' ? JSON.parse(themeVars) : themeVars;
      
      // Appliquer les variables au style du document
      Object.entries(vars).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });
      
      // Définir la police si spécifiée
      if (vars.fontFamily) {
        document.body.style.fontFamily = vars.fontFamily;
      }
      
      // Définir une couleur neutre pour la barre de navigation, indépendamment du thème
      // Pour Android/Chrome
      let themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.setAttribute('name', 'theme-color');
        document.head.appendChild(themeColorMeta);
      }
      themeColorMeta.setAttribute('content', '#FFFFFF'); // Blanc, couleur neutre
      
      // Pour iOS Safari - utiliser "default" pour conserver l'apparence par défaut
      let appleTouchBarMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
      if (!appleTouchBarMeta) {
        appleTouchBarMeta = document.createElement('meta');
        appleTouchBarMeta.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
        document.head.appendChild(appleTouchBarMeta);
      }
      appleTouchBarMeta.setAttribute('content', 'default');
      
      // Pour l'application en mode standalone sur iOS
      let appleWebAppMeta = document.querySelector('meta[name="apple-mobile-web-app-capable"]');
      if (!appleWebAppMeta) {
        appleWebAppMeta = document.createElement('meta');
        appleWebAppMeta.setAttribute('name', 'apple-mobile-web-app-capable');
        document.head.appendChild(appleWebAppMeta);
      }
      appleWebAppMeta.setAttribute('content', 'no'); // Désactiver le mode standalone
      
      // Ne pas changer le motif d'arrière-plan, juste l'opacité si spécifiée
      if (vars.patternOpacity) {
        const patternElement = document.querySelector('.background-pattern');
        if (patternElement) {
          patternElement.style.opacity = vars.patternOpacity;
        }
      }
      
      // Appliquer le motif de fond si spécifié
      if (vars.patternType) {
        applyBackgroundPattern(vars.patternType, vars.patternOpacity, vars.patternSize);
      }
    };

    // Appliquer un motif de fond spécifique
    const applyBackgroundPattern = (type, opacity, size) => {
      const patternElement = document.querySelector('.background-pattern');
      if (!patternElement) return;
      
      // On garde simplement l'opacité
      patternElement.style.opacity = opacity || '0.1';
      
      // Réinitialiser les styles précédents
      patternElement.style.backgroundImage = '';
      patternElement.style.display = '';
      patternElement.style.gridTemplateColumns = '';
      
      // Si c'est le type par défaut ou grid, utiliser la grille CSS avec pseudo-élément
      if (!type || type === 'default' || type === 'grid') {
        patternElement.style.display = 'grid';
        patternElement.style.gridTemplateColumns = 'repeat(36, 1fr)';
        patternElement.style.opacity = opacity || '0.1';
        
        // Créer ou mettre à jour le style pour le pseudo-élément
        let styleElement = document.getElementById('background-pattern-style');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.id = 'background-pattern-style';
          document.head.appendChild(styleElement);
        }
        
        styleElement.textContent = `
          .background-pattern::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: repeating-linear-gradient(
              to right,
              var(--primaryText, #9ca3af) 0px,
              var(--primaryText, #9ca3af) 1px,
              transparent 1px,
              transparent calc(100% / 36)
            );
          }
        `;
        return;
      }
      
      // Sinon, utiliser les motifs SVG comme prévu
      let patternUrl = '';
      switch (type) {
        case 'tribal':
          patternUrl = `url(${BASE_URL}/uploads/patterns/tribal-pattern.svg)`;
          break;
        case 'dots':
          patternUrl = `url(${BASE_URL}/uploads/patterns/dots-pattern.svg)`;
          break;
        case 'arabesque':
          patternUrl = `url(${BASE_URL}/uploads/patterns/arabesque-pattern.svg)`;
          break;
        case 'geometric':
          patternUrl = `url(${BASE_URL}/uploads/patterns/geometric-pattern.svg)`;
          break;
        default:
          // Si le type n'est pas reconnu, revenir au motif par défaut
          patternElement.style.display = 'grid';
          patternElement.style.gridTemplateColumns = 'repeat(36, 1fr)';
          patternElement.style.opacity = opacity || '0.1';
          return;
      }
      
      // Pour les motifs SVG, désactiver la grille et utiliser le background-image
      patternElement.style.display = 'block';
      patternElement.style.backgroundImage = patternUrl;
      patternElement.style.backgroundSize = size || '100px 100px';
      patternElement.style.opacity = opacity || '0.1';
    };

    // Définir le thème par défaut
    const setDefaultTheme = () => {
      const defaultTheme = {
        primaryText: "#000000",
        secondaryText: "#555555",
        borderColor: "rgba(0,0,0,0.08)",
        backgroundColor: "#ffffff",
        accentColor: "#000000",
        buttonHover: "#1a1a1a",
        cardBorderRadius: "8px",
        profileImageBorderRadius: "10px",
        buttonBorderRadius: "30px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        patternOpacity: "0.1",
        patternSize: "20px",
        patternType: "grid"  // Type de motif 'grid' pour utiliser le motif de grille par défaut
      };
      
      applyTheme(defaultTheme);
    };

    // Fonction pour orchestrer le préchargement des ressources et le chargement des données
    const preloadResources = async () => {
      try {
        // Définir l'état de chargement à true au début
        isLoading.value = true;
        
        // Précharger les feuilles de style externes
        const preloadStylesheet = (href) => {
          return new Promise((resolve) => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'style';
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve; // Continuer même en cas d'erreur
            document.head.appendChild(link);
          });
        };

        // Précharger les principales ressources CSS en parallèle
        await Promise.all([
          preloadStylesheet('https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css'),
          preloadStylesheet('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css')
        ]);
        
        // Charger les données nécessaires
        await Promise.all([
          loadUserData(),
          loadUserTheme()
        ]);
      } catch (error) {
        console.error('Erreur lors du préchargement des ressources:', error);
        // S'assurer que tout est marqué comme chargé même en cas d'erreur
        dataLoaded.value = {
          user: true,
          links: true,
          photos: true,
          theme: true
        };
      }
    };

    // NOUVELLE FONCTION: Pour récupérer les liens sociaux
    const getSocialLink = (platformName) => {
      const socialLink = socialLinks.value.find(link => 
        link.platform.toLowerCase() === platformName.toLowerCase()
      );
      return socialLink ? socialLink.url : null;
    };


    const handleServiceClick = (service) => {
    // Enregistrer le clic si possible
    if (user.value && user.value.id && service.id) {
      dashboardService.recordServiceClick?.(user.value.id, service.id)
        .catch(err => console.error('Erreur lors de l\'enregistrement du clic service:', err));
    }
    
    // Ouvrir le lien
    window.open(service.url, '_blank');
  };
    const socialPlatforms = [
      { 
        name: 'Instagram', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png' 
      },
   
      { 
    name: 'X ', 
    displayName: 'X',
    iconUrl: 'https://freelogopng.com/images/all_img/1690643591twitter-x-logo-png.png'
  },
      { 
        name: 'Facebook', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png' 
      },
      { 
        name: 'LinkedIn', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png' 
      },
      { 
        name: 'TikTok', 
        iconUrl: 'https://cdn4.iconfinder.com/data/icons/social-media-flat-7/64/Social-media_Tiktok-512.png' 
      },
      { 
        name: 'YouTube', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Youtube_colored_svg-512.png' 
      },
      { 
        name: 'Snapchat', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Snapchat_colored_svg-512.png' 
      },
      { 
        name: 'Spotify', 
        iconUrl: 'https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Spotify-512.png' 
      }
    ];



    onMounted(async () => {
  try {
    // Vérifier si nous sommes dans Instagram
    if (isInstagramBrowser()) {
      showInstagramPopup();
    }
    
    // Commencer à charger les données
    await preloadResources();
    profileUrl.value = window.location.href;
    
    // FORCER L'AFFICHAGE DU PATTERN APRÈS LE CHARGEMENT
    setTimeout(() => {
      const patternElement = document.querySelector('.background-pattern');
      if (patternElement) {
        // Appliquer le motif de lignes directement
        patternElement.style.backgroundImage = `repeating-linear-gradient(
          to right,
          var(--primaryText, #9ca3af) 0px,
          var(--primaryText, #9ca3af) 1px,
          transparent 1px,
          transparent 25px
        )`;
        patternElement.style.opacity = 'var(--patternOpacity, 0.1)';
        patternElement.style.display = 'block';
      }
    }, 500);
    
    // Enregistrer la vue silencieusement
    if (user.value && user.value.id) {
      const deviceInfo = {
        screen: `${window.innerWidth}x${window.innerHeight}`,
        language: navigator.language,
        platform: navigator.platform
      };
      
      dashboardService.recordProfileView(user.value.id, deviceInfo)
        .catch(err => console.error('Erreur lors de l\'enregistrement de la vue:', err));
    }
  } catch (error) {
    console.error('Erreur:', error);
  }
});


    const instagramPopupShown = ref(false);

// Fonction simplifiée pour détecter Instagram
function isInstagramBrowser() {
  return navigator.userAgent.includes('Instagram');
}

// Fonction pour afficher le popup - simplifiée et optimisée
function showInstagramPopup() {
  // Ne rien faire si déjà affiché
  if (instagramPopupShown.value) return;
  instagramPopupShown.value = true;
  
  // Attendre que le DOM soit prêt
  setTimeout(() => {
    try {
      const popup = document.createElement('div');
      popup.className = 'instagram-popup';
      popup.innerHTML = `
        <div class="instagram-popup-content">
          <div class="popup-header">
            <h3>🌐 Navigation limitée</h3>
            <button class="popup-close">&times;</button>
          </div>
          <div class="popup-body">
            <p><strong>Pour une expérience complète :</strong></p>
            <div class="instruction-steps">
              <p>1. Cliquez sur les <strong>3 points (⋯)</strong> en haut à droite</p>
              <p>2. Sélectionnez <strong>"Ouvrir dans le navigateur"</strong></p>
            </div>
          </div>
          <div class="popup-footer">
            <button class="btn-understood">Compris</button>
          </div>
        </div>
      `;
      
      // Ajouter les styles une seule fois si nécessaire
      if (!document.getElementById('instagram-popup-styles')) {
        const style = document.createElement('style');
        style.id = 'instagram-popup-styles';
        style.textContent = `
          .instagram-popup {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(4px);
            padding: 20px;
            box-sizing: border-box;
          }
          
          .instagram-popup-content {
            width: 100%;
            max-width: 340px;
            background: var(--backgroundColor, #ffffff);
            border-radius: var(--cardBorderRadius, 16px);
            overflow: hidden;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
            border: 1px solid var(--borderColor, rgba(0,0,0,0.1));
            animation: popupSlideIn 0.3s ease-out;
          }
          
          @keyframes popupSlideIn {
            from {
              opacity: 0;
              transform: translateY(-20px) scale(0.95);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          
          .popup-header {
            padding: 20px 20px 15px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid var(--borderColor, rgba(0,0,0,0.1));
            position: relative;
          }
          
          .popup-header h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            flex: 1;
            color: var(--primaryText, #000000);
          }
          
          .popup-close {
            background: none;
            border: none;
            font-size: 24px;
            line-height: 1;
            cursor: pointer;
            color: var(--secondaryText, #666666);
            padding: 5px;
            border-radius: 50%;
            transition: background-color 0.2s;
          }
          
          .popup-close:hover {
            background-color: var(--borderColor, rgba(0,0,0,0.05));
          }
          
          .popup-body {
            padding: 20px;
          }
          
          .popup-body p {
            margin: 0 0 15px 0;
            font-size: 14px;
            color: var(--primaryText, #333333);
            line-height: 1.5;
          }
          
          .popup-body p:last-child {
            margin-bottom: 0;
          }
          
          .instruction-steps {
            background: var(--backgroundColor, #f8f9fa);
            border: 1px solid var(--borderColor, rgba(0,0,0,0.08));
            border-radius: 8px;
            padding: 15px;
            margin-top: 10px;
          }
          
          .instruction-steps p {
            margin: 0 0 8px 0;
            font-size: 13px;
            color: var(--secondaryText, #555555);
            line-height: 1.4;
          }
          
          .instruction-steps p:last-child {
            margin-bottom: 0;
          }
          
          .popup-footer {
            padding: 15px 20px 20px;
            display: flex;
            justify-content: center;
          }
          
          .btn-understood {
            background: var(--accentColor, #007AFF);
            color: white;
            border: none;
            padding: 12px 32px;
            border-radius: var(--buttonBorderRadius, 25px);
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s ease;
            min-width: 120px;
          }
          
          .btn-understood:hover {
            background: var(--accentColorHover, #0056CC);
            transform: translateY(-1px);
          }
          
          .btn-understood:active {
            transform: translateY(0);
          }
          
          /* Responsive design */
          @media (max-width: 480px) {
            .instagram-popup {
              padding: 15px;
            }
            
            .instagram-popup-content {
              max-width: none;
              width: 100%;
            }
            
            .popup-header {
              padding: 15px 15px 12px;
            }
            
            .popup-header h3 {
              font-size: 15px;
            }
            
            .popup-body {
              padding: 15px;
            }
            
            .popup-body p {
              font-size: 13px;
            }
            
            .instruction-steps {
              padding: 12px;
            }
            
            .instruction-steps p {
              font-size: 12px;
            }
            
            .popup-footer {
              padding: 12px 15px 15px;
            }
            
            .btn-understood {
              padding: 11px 24px;
              font-size: 13px;
              min-width: 100px;
            }
          }
          
          @media (max-width: 320px) {
            .popup-header {
              padding: 12px;
            }
            
            .popup-body {
              padding: 12px;
            }
            
            .popup-footer {
              padding: 10px 12px 12px;
            }
          }
        `;
        document.head.appendChild(style);
      }
      
      // Ajouter au body
      document.body.appendChild(popup);
      
      // Gestionnaire pour fermer le popup
      const closePopup = () => {
        if (document.body.contains(popup)) {
          popup.style.animation = 'popupSlideOut 0.2s ease-in forwards';
          setTimeout(() => {
            if (document.body.contains(popup)) {
              document.body.removeChild(popup);
            }
          }, 200);
        }
      };
      
      // Ajouter l'animation de sortie
      if (!document.querySelector('#popup-exit-animation')) {
        const exitStyle = document.createElement('style');
        exitStyle.id = 'popup-exit-animation';
        exitStyle.textContent = `
          @keyframes popupSlideOut {
            from {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
            to {
              opacity: 0;
              transform: translateY(-10px) scale(0.98);
            }
          }
        `;
        document.head.appendChild(exitStyle);
      }
      
      // Event listeners
      popup.querySelector('.popup-close').addEventListener('click', closePopup);
      popup.querySelector('.btn-understood').addEventListener('click', closePopup);
      
      // Fermer en cliquant en dehors
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          closePopup();
        }
      });
      
    } catch (error) {
      console.error('Erreur lors de l\'affichage du popup Instagram:', error);
    }
  }, 2000); // Montrer le popup après 2 secondes
}

    return {
      // État de chargement
      isLoading,
      
      theme,
      user,
      socialLinks,
      photos,
      isGalleryActive,
      showModal,
      currentLink,
      isSaved,
      isFavorite,
      showLinkOptions,
      openInApp,
      openInBrowser,
      closeModal,
      saveContact,
      handleShare,
      addToFavorites,
      findSocialLink,
      error,
      toggleGallery,
      BASE_URL,
      
      // Variables et fonctions pour le modal de partage
      isShareModalOpen,
      copied,
      qrCodeUrl,
      profileUrl,
      closeShareModal,
      copyProfileUrl,
      shareVia,
      socialPlatforms,
      getSocialLink,
      availableSocialPlatforms,
        t,         
        services, // NOUVEAU
        handleServiceClick // NOUVEAU
    };
  },
};
</script>

<style lang="scss" scoped>
/* Styles pour le skeleton loader */
.skeleton {
  background: linear-gradient(90deg, 
    rgba(0, 0, 0, 0.06) 25%, 
    rgba(0, 0, 0, 0.12) 37%, 
    rgba(0, 0, 0, 0.06) 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: var(--cardBorderRadius, 8px);
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.skeleton-banner {
  height: 10rem;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0;
}

.skeleton-text {
  height: 1rem;
  width: 80%;
  margin: 0 auto;
  display: block;
}

.skeleton-name {
  height: 1.4rem;
  width: 60%;
  margin-bottom: 1rem;
}

.skeleton-bio {
  height: 0.9rem;
  width: 80%;
  margin-bottom: 0.5rem;
}

/* Conteneur de chargement principal */
.loading-container {
  position: relative;
  min-height: 100vh;
  
  .content {
    padding-top: 7rem;
    position: relative;
    z-index: 2;
    
    .profile-image-container.skeleton {
      width: 120px;
      height: 120px;
      margin: -0.5rem auto 1.25rem; // Même ajustement
      border-radius: var(--profileImageBorderRadius, 10px);
    }
    
    .profile {
      text-align: center;
      margin-bottom: 2.5rem;
    }
    
    .links {
      display: flex;
      flex-direction: column;
      gap: 0.65rem;
      padding: 0 0.5rem;
      
      .link-item.skeleton {
        height: 3.5rem;
      }
    }
    
    .share-button.skeleton {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
  }
}

/* Variables de thème dynamiques en CSS */
:root {
  --primaryText: #000000;
  --secondaryText: #555555;
  --borderColor: rgba(0, 0, 0, 0.08);
  --backgroundColor: #ffffff;
  --accentColor: #000000;
  --buttonHover: #1a1a1a;
  --cardBorderRadius: 8px;
  --profileImageBorderRadius: 10px;
  --buttonBorderRadius: 30px;
  --patternOpacity: 0.03;
  --patternSize: 20px;
  --galleryImageFilter: grayscale(80%);
}

// Mixins
@mixin flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin hover-effect {
  transition: all 0.25s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  }
}

// Base resets
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

// Base styles
body {
  min-height: 100vh;
  background: var(--backgroundColor);
  padding: 0;
  color: var(--primaryText);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  position: relative;
  max-width: 28rem;
  margin: 0 auto;
  padding-bottom: 2rem; /* Moins d'espace nécessaire maintenant */
}

// Background pattern

.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: var(--patternOpacity, 0.1);
  pointer-events: none;
  z-index: 0;
  
  // S'assurer que le motif est toujours visible
  background-image: repeating-linear-gradient(
    to right,
    var(--primaryText, #9ca3af) 0px,
    var(--primaryText, #9ca3af) 1px,
    transparent 1px,
    transparent 25px
  ) !important;
  display: block !important;
}

// Banner
.banner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 10rem;
  overflow: hidden;
  z-index: -1;

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.8;
  }
  
  .banner-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(17, 24, 39, 0.5), transparent);
  }
}

// Content
.content {
  padding-top: 7rem;
  position: relative;
  z-index: 2;
}

// Share Button - more minimalist
.share-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  @include flex-center;
  transition: all 0.2s;

  i {
    color: var(--primaryText);
    font-size: 14px;
  }

  &:hover {
    background: var(--backgroundColor);
    transform: scale(1.05);
  }
}

// Profile - cleaner, modern look with blur effect
.profile {
  text-align: center;
  margin-bottom: 2.5rem;

  &-image {
    &-container {
      position: relative;
      width: 120px;
      height: 120px;
      margin: -0.5rem auto 1.25rem; // Ajouter margin-top négatif pour remonter
    }

    &-blur {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: linear-gradient(45deg, #93c5fd, #60a5fa);
      filter: blur(20px);
      opacity: 0.7;
      transform: scale(1.1);
    }

    &{
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 4px solid white;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      object-fit: cover;
    }
  }

  &-name {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 0.6rem;
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    color: var(--primaryText);
  }

  &-bio {
    font-size: 0.9rem;
    color: var(--secondaryText);
    max-width: 20rem;
    margin: 0 auto;
    line-height: 1.6;
    font-weight: 400;
  }
}

.verified-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-left: 5px;
}

// Links - style inspiré de la troisième capture d'écran
.links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0 0.5rem;
}

.link-item {
  display: flex;
  align-items: center;
  padding: 0.85rem 1rem;
  background: var(--backgroundColor);
  border: 1px solid var(--borderColor);
  border-radius: var(--cardBorderRadius);
  text-decoration: none;
  color: var(--primaryText);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  @include hover-effect;
  cursor: pointer;

  .link-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    margin-right: 12px;
    
    i {
      font-size: 16px;
      color: var(--primaryText);
    }
  }

  span {
    font-weight: 500;
    font-size: 0.9rem;
    letter-spacing: 0.01em;
  }
}

// Custom yellowdjibouti icon
.custom-icon-yellow {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  filter: grayscale(100%);  // Make it B&W
}

// Gallery
.gallery {
  &-item {
    padding: 0;
    overflow: hidden;
  }
  
  &-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.85rem 1rem;
    text-align: left;
  }

  &-content {
    display: flex;
    align-items: center;
    
    .link-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      margin-right: 12px;
      
      i {
        font-size: 16px;
        color: var(--primaryText);
      }
    }
    
    span {
      font-weight: 500;
      font-size: 0.9rem;
      letter-spacing: 0.01em;
    }
  }

  &-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    padding: 0 1rem 1rem;
    overflow: hidden;
    transition: all 0.35s ease;
    max-height: 0;
    opacity: 0;

    &.active {
      max-height: 500px;
      opacity: 1;
      margin-top: 0.5rem;
    }

    .gallery-image {
      width: 100%;
      aspect-ratio: 1/1;
      object-fit: cover;
      border-radius: 6px;
      transition: transform 0.3s;
      border: 1px solid var(--borderColor);
      filter: var(--galleryImageFilter);

      &:hover {
        transform: scale(1.03);
        filter: grayscale(40%);  // Reveal some color on hover
      }
    }
  }
}

.chevron {
  transition: transform 0.3s;
  font-size: 12px;
  color: var(--secondaryText);

  &.active {
    transform: rotate(180deg);
  }
}

// Modal style - cleaner, more modern
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.modal-content {
  background-color: var(--backgroundColor);
  padding: 1.5rem;
  border-radius: 16px 16px 0 0;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.1);

  h3 {
    text-align: center;
    margin-bottom: 1.2rem;
    font-size: 0.9rem;
    color: var(--secondaryText);
    font-weight: 500;
    letter-spacing: 0.03em;
  }

  button {
    width: 100%;
    padding: 0.9rem;
    margin-bottom: 0.7rem;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    transition: all 0.2s;

    i {
      margin-right: 0.5rem;
      font-size: 1rem;
    }
    
    &.app-button {
      background: var(--accentColor);
      color: white;
      
      &:hover {
        background: var(--buttonHover);
      }
    }
    
    &.browser-button {
      background: #f2f2f2;
      color: var(--primaryText);
      
      &:hover {
        background: #e6e6e6;
      }
    }
    
    &.cancel-button {
      background: transparent;
      border: 1px solid var(--borderColor);
      color: var(--secondaryText);
      
      &:hover {
        background: #f8f8f8;
      }
    }
  }
}

// Share modal
.share-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.share-modal-content {
  background: var(--backgroundColor);
  width: 90%;
  max-width: 440px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.share-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid var(--borderColor);

  h4 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--primaryText);
  }

  .close-button {
    background: none;
    border: none;
    font-size: 1.2rem;
    color: var(--secondaryText);
    cursor: pointer;
    padding: 0;
    line-height: 1;
    
    &:hover {
      color: var(--primaryText);
    }
  }
}

// Layout with QR code left and options right
.content-layout {
  display: flex;
  align-items: stretch;
}

.qr-code-container {
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
}

.qr-image {
  width: 110px;
  height: 110px;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  background: white;
  padding: 5px;
}

.share-options {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.share-option {
  display: flex;
  align-items: center;
  padding: 0.9rem 1.2rem;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid var(--borderColor);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8f8f8;
  }

  .social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    margin-right: 0.9rem;
    color: var(--primaryText);
  }

  span {
    flex: 1;
    font-size: 0.85rem;
    color: var(--primaryText);
    font-weight: 500;
  }

  .chevron-right {
    margin-left: 5px;
    color: #cccccc;
  }
}

// URL Copy section
.url-copy {
  display: flex;
  margin: 1rem 1.2rem;
  align-items: center;
  border: 1px solid var(--borderColor);
  border-radius: 6px;
  background-color: #f8f8f8;
  overflow: hidden;
}

.url-icon {
  display: flex;
  align-items: center;
  padding: 0 0.7rem;
  color: var(--secondaryText);
}

.url-input {
  flex: 1;
  padding: 0.8rem 0.5rem 0.8rem 0;
  font-size: 0.8rem;
  border: none;
  background: transparent;
  color: var(--primaryText);
  outline: none;
}

.copy-button {
  padding: 0.8rem 1rem;
  background: var(--accentColor);
  border: none;
  color: white;
  font-weight: 500;
  font-size: 0.75rem;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  transition: background 0.2s;
  
  &:hover {
    background: var(--buttonHover);
  }
}

// Social Icons Bar
.social-icons-bar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px auto;
  max-width: 80%;
}

.social-icon-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }
}

.social-platform-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

// Bottom buttons - more minimal
.bottom-buttons {
  position: relative;
  margin: 2rem auto;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 5;
}

.bottom-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.8rem;
  background: var(--backgroundColor);
  border: 1px solid var(--borderColor);
  border-radius: var(--buttonBorderRadius);
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.2s;
  font-size: 0.85rem;
  font-weight: 500;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  &.active {
    background: var(--accentColor);
    color: white;
    border-color: var(--accentColor);
  }

  i {
    font-size: 1rem;
  }
}

// Footer style avec logo cliquable - dimensions adaptées
.create-profile-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem; // Espacement vertical
}



.save-contact-button {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1.2rem;
  background: var(--accentColor);
  color: white;
  border: none;
  border-radius: var(--buttonBorderRadius, 25px);
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  min-width: auto;
  max-width: 140px;
  
  &:hover {
    background: var(--buttonHover);
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  i {
    font-size: 0.75rem;
  }
  
  span {
    white-space: nowrap;
  }
}



@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.neolink-logo {
  width: 25px; // Taille réduite
  height: auto;
}

.logo-tooltip {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%) translateY(0);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
  
  i {
    font-size: 12px;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
}

.create-profile-link {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  color: var(--secondaryText);
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    color: var(--primaryText);
  }
}

.create-profile-link {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  color: var(--primaryText);
  transition: transform 0.2s ease;
}

.create-profile-link:hover {
  transform: translateY(-1px);
}

.highlight-text {
  color: var(--accentColor);
  font-weight: 600;
}

// Style pour le bouton d'enregistrement
.bottom-button.save-button {
  background: var(--accentColor);
  color: white;
  border: none;
}

.bottom-button.save-button:hover {
  background: var(--buttonHover);
}

.bottom-button.save-button i {
  color: white;
}

// Media Queries
@media (min-width: 768px) {
  .modal {
    align-items: center;
  }

  .modal-content {
    border-radius: 12px;
    max-width: 360px;
  }
  
  .share-modal-content {
    width: 80%;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 90%;
  }
  
  .banner {
    height: 8rem;
  }
  
  .content {
    padding-top: 6rem;
  }

  .profile {
    &-image-container {
      width: 100px;
      height: 100px;
      margin: -0.3rem auto 1.25rem; // Moins de remontée sur tablette
    }
    
    &-name {
      font-size: 1.25rem;
    }

    &-bio {
      font-size: 0.85rem;
    }
  }

  .bottom-buttons {
    bottom: 1.2rem;
  }
}

@media (max-width: 480px) {
  .container {
    max-width: 100%;
    padding: 0 1rem 4rem;
  }
  
  .links {
    gap: 0.5rem;
  }
  
  .gallery-grid {
    padding: 0 0.8rem 0.8rem;
    gap: 0.4rem;
  }

  .profile {
    &-image-container {
      width: 90px;
      height: 90px;
      margin: -0.2rem auto 1.25rem; // Encore moins sur mobile
    }
  }
  
  .content-layout {
    flex-direction: column;
  }
  
  .share-options {
    border-top: 1px solid var(--borderColor);
  }
  
  .qr-code-container {
    padding: 1rem;
  }
  
  .qr-image {
    width: 90px;
    height: 90px;
  }
  
  .bottom-button {
    padding: 0.7rem 1.3rem;
    
    span {
      display: none;
    }
    
    i {
      margin: 0;
      font-size: 1.1rem;
    }
  }
}


// AJOUTER CES STYLES DANS NeolinkView.vue <style>




// ===== SERVICES STYLES =====


// ===== SERVICES STYLES =====


// Style pour les services de type "button"
.service-item {
  position: relative;
  
  &[data-type="button"] {
    flex-direction: column;
    text-align: center;
    padding: 0;
    min-height: 120px;
    overflow: hidden;
    background: var(--backgroundColor); // Utiliser la couleur de fond du thème
  }
}

.service-button-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
  position: relative;
}

.service-image-container {
  width: 100%;
  height: 80px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}

.service-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.service-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  color: var(--secondaryText);
  
  i {
    font-size: 32px;
    opacity: 0.5;
  }
}

.service-button-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--primaryText);
  text-align: center;
  line-height: 1.3;
  padding: 1rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--backgroundColor); // AJOUTER cette ligne pour le fond du thème
}

// S'assurer que link-item n'ajoute pas de padding pour les boutons
.link-item {
  &[data-type="button"] {
    padding: 0 !important;
  }
}

// Responsive pour les services button
@media (max-width: 480px) {
  .service-image-container {
    height: 70px;
  }
  
  .service-button-name {
    font-size: 0.85rem;
    padding: 0.75rem;
  }
  
  .service-item[data-type="button"] {
    min-height: 100px;
  }
}
</style>